import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './index.css'
import '@wangeditor/editor/dist/css/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)
// wangEditor css 

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'http://localhost:5001/api/'
// Vue.prototype.$imgUrl = 'http://localhost:5001/api/File/UploadingFormFile'
// // 图片服务器地址
// Vue.prototype.imgserver = 'http://localhost:5001/'


// axios.defaults.baseURL = 'http://www.huaxinyan.com/api'
// Vue.prototype.$imgUrl = 'http://www.huaxinyan.com/api/File/UploadingFormFile'
// // 图片服务器地址
// Vue.prototype.imgserver = ''


axios.defaults.baseURL = '/api/'
Vue.prototype.$imgUrl = '/api/File/UploadingFormFile'
Vue.prototype.imgserver = ''
// 如果有token 就给所有的请求拦截器加上token
// 请求拦截器上添加bearer token 
axios.interceptors.request.use(config => {
let token = sessionStorage.getItem('token')

  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}, error => {
  return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use(response => {
  if (response.data.code == 401) {
    router.push('/login')
  }
  return response.data
}, error => {
  // 如果是401 就跳转到登录页面
  if (error.response.status == 401) {
    // 提示用户
    ElementUI.Message.error('请先登录')
    // 跳转到登录页面
    router.push('/login')
  }
  return Promise.reject(error)
})
Vue.prototype.$http = axios


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')